import { withLayout } from '../../../layout';

import Connect from './connect.page';

export default withLayout(Connect);
